import { Translation } from '@ps/web-shared-components';
import React from 'react';

import styles from '../shared.scss';

import { TXTCLI_Buy_In } from './BuyIn.messages.json';

export interface BuyInProps {
  scriptId: number;
  buyIn: string;
}

function BuyIn({ scriptId, buyIn }: BuyInProps) {
  return (
    <>
      <div className={styles.label} key={scriptId}>
        <Translation {...TXTCLI_Buy_In} />
      </div>
      <div className={styles.value}>
        <div>{buyIn}</div>
      </div>
    </>
  );
}

export default BuyIn;
